import { manageFlowBookingSelector } from '@/features/manage/manageSelectors';
import { exchangeOperationIdSelector } from '@/features/purchase/purchaseSelectors';
import { useSelector } from '@/store/utils';
import type { ExchangeOperationDTO } from '@/types/dto/agent';

/**
 * The exchange operation created in THIS session — resolved by matching
 * the id `startExchange` produced (`purchase.exchangeOperation.id`) against
 * the full operations on the managed booking. Returns `undefined` before
 * `startExchange` runs, or once the operation is gone.
 *
 * Matching by our own session id (rather than "any non-terminal op") is
 * deliberate: a booking can carry leftover operations from earlier
 * abandoned modifications, and we must only ever track the one this flow
 * created — for the change-total/reusable-sum reads and the expiry timer.
 */
export const useStartedExchangeOperation = ():
  | ExchangeOperationDTO
  | undefined => {
  const startedExchangeId = useSelector(exchangeOperationIdSelector);
  const manageBooking = useSelector(manageFlowBookingSelector);

  if (!startedExchangeId) return undefined;
  return manageBooking?.exchangeOperations?.find(
    (op) => op.id === startedExchangeId
  );
};
